export default "__VITE_ASSET__DakVcyW2__"